import React from "react";

const Home = (props)=>{
     return(
          <div className="container-scroller">
               <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
                    <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                         <a className="navbar-brand brand-logo" href="/admin-dashboard"><img src="assets/images/admin.png" alt="logo" /></a>
                         <a className="navbar-brand brand-logo-mini" href="/admin-dashboard"><img src="assets/images/admin-logo.png" alt="logo" /></a>
                    </div>
                    <div className="navbar-menu-wrapper d-flex align-items-stretch">
                         <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                    <span className="mdi mdi-menu"></span>
                    </button>
                         <ul className="navbar-nav navbar-nav-right">
                              <li className="nav-item d-none d-lg-block full-screen-link">
                                   <a className="nav-link">
                                        <i className="mdi mdi-fullscreen" id="fullscreen-button"></i>
                                   </a>
                                   </li>
                              <li className="nav-item nav-logout d-none d-lg-block" onClick={()=>{
                                             document.cookie = 'authx=; Max-Age=0;secure';
                                             window.location.reload();
                                        }}>
                                   <a className="nav-link">
                                        <i className="mdi mdi-power"></i>
                                   </a>
                              </li>
                              <li className="nav-item nav-settings d-none d-lg-block">
                                   <a className="nav-link" href="#">
                                        <i className="mdi mdi-format-line-spacing"></i>
                                   </a>
                              </li>
                         </ul>
                         <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
                    <span className="mdi mdi-menu"></span>
                    </button>
                    </div>
               </nav>
               
               <div className="container-fluid page-body-wrapper">
               
                    <nav className="sidebar sidebar-offcanvas" id="sidebar">
                         <ul className="nav">     
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-dashboard" >
                                        <span className="menu-title">Dashboard</span>
                                        <i className="mdi mdi-home menu-icon"></i>
                                   </a>
                              </li>     
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-campaign" >
                                        <span className="menu-title">Campaign</span>
                                        <i className="mdi mdi-google-analytics menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-inactive-users" >
                                        <span className="menu-title">Inactive users</span>
                                        <i className="mdi mdi-account-group menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-lotterys">
                                        <span className="menu-title">Lottery</span>
                                        <i className="mdi mdi-cube menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-orders">
                                        <span className="menu-title">Orders</span>
                                        <i className="mdi mdi-credit-card menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-results">
                                        <span className="menu-title">Results</span>
                                        <i className="mdi mdi-calendar-month menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-winners">
                                        <span className="menu-title">Winners</span>
                                        <i className="mdi mdi-human-handsup menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-history">
                                        <span className="menu-title">History</span>
                                        <i className="mdi mdi-history menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-txns">
                                        <span className="menu-title">Transaction</span>
                                        <i className="mdi mdi-account-clock menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-notification">
                                        <span className="menu-title">Notification</span>
                                        <i className="mdi mdi-bell menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-block-inactive-users">
                                        <span className="menu-title">Block Users</span>
                                        <i className="mdi mdi-cancel menu-icon"></i>
                                   </a>
                              </li>
                              <li className="nav-item">
                                   <a className="nav-link" href="/admin-setting">
                                        <span className="menu-title">Setting</span>
                                        <i className="mdi mdi-settings menu-icon"></i>
                                   </a>
                              </li>
                         </ul>
                    </nav>
                    
                    <div className="main-panel">
                         <div className="content-wrapper">
                              {props.children}
                         </div>
                    </div>
               </div>
          </div>
     );
}

export default Home;